import React, { useState } from 'react';
import DocumentUpload from './components/DocumentUpload';
import ValidationResponse from './components/ValidationResponse';
import 'bulma/css/bulma.min.css';
import './App.css';

function App() {
  // State to share validation result between upload and response
  const [validationResult, setValidationResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="App">
      {/* Main content section with headline and description */}
      <section className="section main-section">
        <div className="main-container">
          <div className="headline-container">
            <h2 className="sub-headline">Document Validation</h2>
          </div>

          {/* Card-based content layout */}
          <div className="features-grid">
            <div className="feature-card">
              <h3 className="feature-title">Upload</h3>
              <div className="upload-section">
                <DocumentUpload
                  setValidationResult={setValidationResult}
                  setIsLoading={setIsLoading}
                />
              </div>
            </div>

            <div className="feature-card">
              <h3 className="feature-title">Results</h3>
              <div className="response-section">
                <ValidationResponse
                  validationResult={validationResult}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer with logo */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src="https://skillsync.com.au/wp-content/uploads/2023/10/cropped-Untitled-1.png"
              alt="SkillSync Logo"
              className="logo"
            />
          </div>
          <div className="footer-text">
            <p className="copyright">© 2025 SkillSync</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;